import { z } from 'zod';
export const BehaviorSectionSchema = z.object({
    summary: z.string(),
    details: z.array(z.string())
});
export const TransactionBehaviorSchema = z.object({
    pricing: BehaviorSectionSchema,
    average_ticket_size: BehaviorSectionSchema,
    issuer_geographic_distribution: BehaviorSectionSchema,
    velocity: BehaviorSectionSchema,
    cardholder_bin: BehaviorSectionSchema,
    refunds: BehaviorSectionSchema,
    time_of_day: BehaviorSectionSchema,
    cluster_findings: BehaviorSectionSchema,
    authorization_patterns: BehaviorSectionSchema
}).meta({
    id: 'TransactionBehavior'
});

//# sourceMappingURL=transaction-behavior.schema.js.map